import { cx } from '@/lib/cx';

import { BotaoCopiar } from './copiar';

interface ChaveAcessoProps {
  chave: string;
  /** Compacta mostra só o começo e o fim (para tabelas); a completa vem em blocos de 4. */
  compacta?: boolean;
  copiavel?: boolean;
  className?: string;
}

/** Os blocos de 4 alternam a intensidade da tinta, como na impressão do DANFE: o olho acha a posição. */
export function ChaveAcesso({
  chave,
  compacta = false,
  copiavel = false,
  className,
}: ChaveAcessoProps) {
  const blocos = chave.match(/.{1,4}/g) ?? [chave];
  return (
    <span className={cx('inline-flex items-center gap-1', className)}>
      {/* A completa quebra entre blocos (nunca dentro de um) para caber no celular. */}
      <span
        className={cx('chave-blocos text-sm', compacta && 'whitespace-nowrap')}
        aria-label={`Chave de acesso ${chave}`}
      >
        {compacta ? (
          <span aria-hidden>
            {blocos.slice(0, 2).join(' ')} … {blocos.slice(-2).join(' ')}
          </span>
        ) : (
          blocos.map((bloco, i) => (
            <span key={i} aria-hidden className={i % 2 === 0 ? 'text-texto' : 'text-texto-suave'}>
              {bloco}{' '}
            </span>
          ))
        )}
      </span>
      {copiavel && <BotaoCopiar texto={chave} rotulo="Copiar chave de acesso" />}
    </span>
  );
}
